import { useCallback, useEffect, useState } from "react"
import { getClinicStatus } from "../services/subscriptionsService"

export function useClinicSubscription(clinicId) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    if (!clinicId || clinicId === "ALL") {
      setData(null)
      setError(null)
      setLoading(false)
      return
    }

    try {
      setLoading(true)
      setError(null)

      const response = await getClinicStatus(clinicId)
      setData(response || null)
      setError(null)
    } catch (err) {
      setData(null)
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [clinicId])

  useEffect(() => {
    load()
  }, [load])

  useEffect(() => {
    function handleSubscriptionUpdated() {
      load()
    }

    window.addEventListener(
      "odontoflow:subscription-updated",
      handleSubscriptionUpdated
    )

    window.addEventListener(
      "odontoflow:clinics-updated",
      handleSubscriptionUpdated
    )

    return () => {
      window.removeEventListener(
        "odontoflow:subscription-updated",
        handleSubscriptionUpdated
      )

      window.removeEventListener(
        "odontoflow:clinics-updated",
        handleSubscriptionUpdated
      )
    }
  }, [load])

  return {
    subscription: data,
    loading,
    error,
    refresh: load
  }
}